import {
    GIFT_CARD_API,
    PAYMENT_API,
    CARD_PAYMENT_FAILED,
    VOID_ALL_PAYMENTS
} from "./actionTypes";
import $ from "jquery";
import {getPeripheral} from "../selectors";
import {
    addErrorAlert,
    addPeripheral,
    changePaymentMode,
    checkHealthStatus,
    removePeripheral,
    setLoading,
    showDialogue,
    updatePeripheral
} from "../actions";
import Peripheral from "../dto/peripheral";
import {CANCEL_TRANSACTION, CHANGE_MODE, INIT_TRANSACTION, SCANNER_DETECTED} from "../actionTypes";
import {
    addCardPaymentProgressMessage,
    removePayment,
    transactionCancelled,
    updatePayment,
    voidCardPayment,
    voidGiftCardPayment,
    voidIntegratedPayment
} from "./actions";
import {APP_MODE_PAYMENT, PAYMENT_MODE_OPTIONS} from "../appConstants";
import {checkGiftCard, giftCard, posEvents as giftCardPOSEvents} from "./integrations/giftCard/middleware";
import {checkGiftCard as checkGiftCardErply, giftCard as giftCardErply, posEvents as giftCardPOSEventsErply} from "./integrations/giftCardErply/middleware";
import {getPayment} from "./selectors";

const paymentMiddleware = (store) => next => action => {
    next(action);
    const state = Object.assign({}, store.getState());

    if (action.type === SCANNER_DETECTED) {
        const scannedCode = action.payload;
        if(state.rootReducer.paymentMode === 'giftCard'){
            store.dispatch(changePaymentMode("giftCardCheck"));
            if(process.env.REACT_APP_ERPLY_MODE !== "1"){
                return checkGiftCard(store.dispatch, state, scannedCode, true, (success)=>{});
            }else{
                return checkGiftCardErply(store.dispatch, state, scannedCode, true, (success)=>{});
            }
        }

    }else if (action.type === GIFT_CARD_API){
        if(process.env.REACT_APP_ERPLY_MODE !== "1"){
            return giftCard(store, state, action.payload);
        }else{
            return giftCardErply(store.dispatch, state, action.payload);
        }
    }else if (action.type === CHANGE_MODE){
        if(action.payload.mode === APP_MODE_PAYMENT){
            if(process.env.REACT_APP_ERPLY_MODE !== "1"){
                giftCardPOSEvents.beforeSaveTransaction(store);
            }else{
                giftCardPOSEventsErply.beforeSaveTransaction(store);
            }
        }
    }else if (action.type === INIT_TRANSACTION){
        if(process.env.REACT_APP_ERPLY_MODE !== "1"){
            giftCardPOSEvents.initTransaction();
        }else{
            giftCardPOSEventsErply.initTransaction();
        }
    }else if (action.type === CANCEL_TRANSACTION){
        store.dispatch(transactionCancelled());
    }else if (action.type === CARD_PAYMENT_FAILED){
        store.dispatch(changePaymentMode(PAYMENT_MODE_OPTIONS));
        store.dispatch(removePayment(action.payment));
        store.dispatch(addErrorAlert(action.message));
        return;
    }else if (action.type === VOID_ALL_PAYMENTS){
        state.payment.payments.forEach((paymentData) => {
            let payment = getPayment(paymentData);
            if(payment.type === 'CARD'){
                payment.status = 'voiding';
                store.dispatch(updatePayment(payment));
                let tryVoidCardPayment = () => {
                    store.dispatch(setLoading(true));
                    store.dispatch(voidCardPayment(payment, () => {
                        store.dispatch(setLoading(false));
                        return removePayment(payment);
                    }, (message = '') => {
                        store.dispatch(setLoading(false));
                        return showDialogue('Could not void payment', message, 'retry', () => {
                            tryVoidCardPayment();
                        }, () => {
                            store.dispatch(removePayment(payment));
                        }, 'cancel', false);
                    }));
                };
                tryVoidCardPayment();
            }else if(payment.isIntegrated){
                payment.status = 'voiding';
                store.dispatch(updatePayment(payment));
                let tryVoidIntegratedPayment = () => {
                    store.dispatch(setLoading(true));
                    store.dispatch(voidIntegratedPayment(payment, () => {
                        store.dispatch(setLoading(false));
                        return removePayment(payment);
                    }, (message = '') => {
                        store.dispatch(setLoading(false));
                        return showDialogue('Could not void payment', message, 'retry', () => {
                            tryVoidIntegratedPayment();
                        }, () => {
                            store.dispatch(removePayment(payment));
                        }, 'cancel', false);
                    }));
                };
                tryVoidIntegratedPayment();
            } else if(payment.type === 'GIFTCARD'){
                let tryVoidGiftCardPayment = () => {
                    store.dispatch(voidGiftCardPayment(payment.giftCard.transactionID, () => {
                        store.dispatch(removePayment(payment));
                    }, () => {
                        store.dispatch(showDialogue('', 'Could not void gift card payment', 'retry', () => {
                            tryVoidGiftCardPayment();
                        }, () => {
                            store.dispatch(removePayment(payment));
                        }, 'cancel', false));
                    }));
                };
                if(payment.status === 'success'){
                    tryVoidGiftCardPayment();
                }
            }else{
                store.dispatch(removePayment(payment));
            }
        });
    }

    if (action.type !== PAYMENT_API) {
        return;
    }
    const {
        data,
        onSuccess,
        onFailure,
        successActions
    } = action.payload;


    const integrationName = typeof data?.integration === "string" ? data.integration : data?.integration?.type ?? state.payment.integration;

    const handlePayment = () => {
        import('./integrations/' + integrationName + '/middleware').then((module) => {
            //store.dispatch(addCardPaymentProgressMessage("Follow payment terminal instructions"));
            if(data.request === "processCard"){
                data.cardPayment = getPayment(data.cardPayment);
            }
            module.default(data, function (result) {
                store.dispatch(onSuccess(result));
                if(successActions){
                    $(successActions).each(function (index, successAction) {
                        store.dispatch(successAction(result));
                    });
                }
            }, function (payment, result) {
                store.dispatch(onFailure(payment, result));
            }, state, function (connected) {
                console.log('payment middleware: connectionStateChange', connected);
                const peripheral = getPeripheral(store.getState().rootReducer.peripherals, 'paymentTerminal');
                if(peripheral !== false){
                    if(connected){
                        peripheral.setConnected();
                    }else{
                        peripheral.setConnectionFailed();
                    }
                    store.dispatch(updatePeripheral(peripheral));
                }
            }, (progressMessage) => {
                store.dispatch(addCardPaymentProgressMessage(progressMessage));
            }, store.dispatch, store);
        }, () => {
            store.dispatch(checkHealthStatus(5));
            if(data.request === 'login'){
                store.dispatch(removePeripheral('paymentTerminal'));
                store.dispatch(addErrorAlert('Payment terminal is not available!'));
            }else if (data.request === 'processCard'){
                store.dispatch(onFailure(data.cardPayment, 'Payment terminal is not available!'));
            }else if (data.request === 'processPayment'){
                console.log("Payment integration loading failed!");
                store.dispatch(onFailure(data.payment, 'Integrated payment is not available'));
            }
        });
    }

    if(data.request === 'login'){
        let peripheral = new Peripheral('paymentTerminal');
        peripheral.setConnecting();
        peripheral.onRetry = () => {
            peripheral.setConnecting();
            store.dispatch(updatePeripheral(peripheral));
            handlePayment();
        }
        store.dispatch(addPeripheral(peripheral));
    }

    handlePayment();
};

export default paymentMiddleware;
